import { isDev } from 'embed/constants/config'
import QueryParams from 'common/services/QueryParams'
import { QueryParamKeys } from 'even-ts-static'

import './cohorts'

import { Experiment as ExperimentType } from './types'

import Experiment from './components/Experiment'
import Original from './components/Original'
import Variant from './components/Variant'
import withExperiment from './components/WithExperiment'

// The experiments framework is enabled if gtag exists and we are either not in dev or the 'experiments=true' query param is present
export const ExperimentsEnabled =
  // tslint:disable-next-line: strict-type-predicates
  (window.gtag !== undefined && !isDev) || QueryParams.getAll()[QueryParamKeys.Experiments]

// Experiment definitions

export const LoanPlaidIntegration: ExperimentType = {
  activationEvent: 'optimize.activate.0gEcGDiUTwGttHyUU7SfhA',
  id: '0gEcGDiUTwGttHyUU7SfhA',
  variants: {
    plaidEnabled: { id: '1' },
  },
}

export const PreSelectApplicationForm: ExperimentType = {
  activationEvent: 'optimize.activate.-RWPhuNkRNKwrTWnMo4bFg',
  id: '-RWPhuNkRNKwrTWnMo4bFg',
  variants: {
    shouldStartOnApplicationStep: { id: '1' },
  },
}

export const DoNotRedirectPilotPartners: ExperimentType = {
  activationEvent: 'optimize.activate.vY1_vNeySJWSiHWw1Sycag',
  id: 'vY1_vNeySJWSiHWw1Sycag',
  variants: {
    doNotRedirect: { id: '1' },
  },
}

export const StepByStepPlaidSummaryCard: ExperimentType = {
  activationEvent: 'optimize.activate.Up3WnNPGSbWULewGLp7zww',
  id: 'Up3WnNPGSbWULewGLp7zww',
  variants: {
    withPlaidSummaryCard: { id: '1' },
  },
}

export const PlaidSummaryCardSingleStep: ExperimentType = {
  activationEvent: 'optimize.activate.YYVv8otaSImAPo8AcmrqvA',
  id: 'YYVv8otaSImAPo8AcmrqvA',
  variants: {
    withSummaryCard: { id: '1' },
  },
}

export const AprVsRecSorting: ExperimentType = {
  activationEvent: 'optimize.activate.-BOUdLhAQwOqN-8xBtmeGQ',
  id: '-BOUdLhAQwOqN-8xBtmeGQ',
  variants: {
    Apr: { id: '1' },
    ConversionProbability: { id: '2' },
  },
}

export const NoPreviewIntroForm: ExperimentType = {
  activationEvent: 'optimize.activate.NuCFA8gXQCeDzMKYqQV1NQ',
  id: 'NuCFA8gXQCeDzMKYqQV1NQ',
  variants: {
    noOffersIntro: { id: '1' },
  },
}

export const RedirectPreferredLook: ExperimentType = {
  activationEvent: 'optimize.activate.78RfKPLXSo2PZkDo-RHDTQ',
  id: '78RfKPLXSo2PZkDo-RHDTQ',
  variants: {
    Redirect: { id: '1' },
    RedirectPreferred: { id: '2' },
    RedirectPreferredNewTemplate: { id: '3' },
  },
}

export const CreditCardIntroVsPreviewStep: ExperimentType = {
  activationEvent: 'optimize.activate.KYPSRCk7R26lxf2YvlzF_A',
  id: 'KYPSRCk7R26lxf2YvlzF_A',
  variants: {
    IntroStep: {
      id: '1',
    },
  },
}

export const PreviewOfferCtaLanguage: ExperimentType = {
  activationEvent: 'optimize.activate.4Q9SbyE3ReKAIpgPPFJMVw',
  id: '4Q9SbyE3ReKAIpgPPFJMVw',
  objectiveEvent: `optimize.objective.4Q9SbyE3ReKAIpgPPFJMVw`,
  variants: {
    GetMatched: {
      id: '1',
    },
    CheckMyRates: {
      id: '2',
    },
    ContinueWithLabel: {
      id: '3',
    },
    CheckMyRatesWithLabel: {
      id: '4',
    },
    SeeIfYouMayQualify: {
      id: '5',
    },
  },
}

export const StepByStepAlternateContinueButtonLang: ExperimentType = {
  activationEvent: 'optimize.activate.xPFLG9t8SKKyy5R7nu_t9g',
  id: 'xPFLG9t8SKKyy5R7nu_t9g',
  objectiveEvent: `optimize.objective.xPFLG9t8SKKyy5R7nu_t9g`,
  variants: {
    GetStarted: {
      id: '1',
    },
  },
}

export const StepByStepApplicationHelperText: ExperimentType = {
  activationEvent: 'optimize.activate.iom4mnC1TFeGqYX6-tQYeQ',
  id: 'iom4mnC1TFeGqYX6-tQYeQ',
  variants: {
    ExposedHelperText: {
      id: '1',
    },
  },
}

export const CCIntroVsPreviewVsHybridOfferList: ExperimentType = {
  activationEvent: 'optimize.activate.J6gmRbdPT42s9ulXF4jl-Q',
  id: 'J6gmRbdPT42s9ulXF4jl-Q',
  variants: {
    HybridOfferList: {
      id: '1',
    },
    Preview: {
      id: '2',
    },
    IntroStep: {
      id: '3',
    },
  },
}

export const BBBRatingsOnLoanOffers: ExperimentType = {
  activationEvent: 'optimize.activate.ksFniSLLSJemv00En1ZOnA',
  id: 'ksFniSLLSJemv00En1ZOnA',
  objectiveEvent: 'optimize.objective.ksFniSLLSJemv00En1ZOnA',
  variants: {
    BBBRatings: {
      id: '1',
    },
  },
}

export const StepByStepLoanSliderInput: ExperimentType = {
  activationEvent: 'optimize.activate.XMTrqMLkSGe6NCmoOancWw',
  id: 'XMTrqMLkSGe6NCmoOancWw',
  variants: {
    SliderInput: {
      id: '1',
    },
  },
}

export const TrustBadgesInFooter: ExperimentType = {
  activationEvent: 'optimize.activate.YrC_upBMQoqv6TqAGvOPLw',
  id: 'YrC_upBMQoqv6TqAGvOPLw',
  variants: {
    EmbedWithBadges: {
      id: '1',
    },
  },
}

export const ShowAllOffersOnResultsStep: ExperimentType = {
  activationEvent: 'optimize.activate.-vjOr3dnTZ6j8b2Wf8dG9w',
  id: '-vjOr3dnTZ6j8b2Wf8dG9w',
  objectiveEvent: `optimize.objective.-vjOr3dnTZ6j8b2Wf8dG9w`,
  variants: {
    ShowAllOffers: {
      id: '1',
    },
  },
}

export const SortByClosestLoanAmount: ExperimentType = {
  activationEvent: 'optimize.activate.wmltJEuFSKy2xpxFd_KTNg',
  id: 'wmltJEuFSKy2xpxFd_KTNg',
  objectiveEvent: `optimize.objective.wmltJEuFSKy2xpxFd_KTNg`,
  variants: {
    SortByClosestAmount: {
      id: '1',
    },
  },
}

export const LoanOffersFilterDrawer: ExperimentType = {
  activationEvent: 'optimize.activate.-Zlx3VtuQmKACF7yO7oLnA',
  id: '-Zlx3VtuQmKACF7yO7oLnA',
  objectiveEvent: `optimize.objective.-Zlx3VtuQmKACF7yO7oLnA`,
  variants: {
    AllOffersWithFilterDrawer: {
      id: '1',
    },
  },
}

export const LoanOffersGroupedBySubType: ExperimentType = {
  activationEvent: 'optimize.activate.EigMJ4UFRauNPz5bTvP7MQ',
  id: 'EigMJ4UFRauNPz5bTvP7MQ',
  objectiveEvent: `optimize.objective.EigMJ4UFRauNPz5bTvP7MQ`,
  variants: {
    GroupedOffers: {
      id: '1',
    },
  },
}

export const JustATest: ExperimentType = {
  activationEvent: 'optimize.activate.I4BxLsZRTA61gr7Sq3RKoQ',
  id: 'I4BxLsZRTA61gr7Sq3RKoQ',
  objectiveEvent: `optimize.objective.I4BxLsZRTA61gr7Sq3RKoQ`,
  variants: {
    JustATest: {
      id: '1',
    },
  },
}

export const StepByStepLoansAvatar: ExperimentType = {
  activationEvent: 'optimize.activate.zvVc3PWtQSOj4eodkmLgKw',
  id: 'zvVc3PWtQSOj4eodkmLgKw',
  variants: {
    Avatar: {
      id: '1',
    },
  },
}

export const StepByStepPayFrequencyAndEmploymentStatusIcons: ExperimentType = {
  activationEvent: 'optimize.activate.hKDmuYahRgKPa_JNyTuhYA',
  id: 'hKDmuYahRgKPa_JNyTuhYA',
  objectiveEvent: `optimize.objective.hKDmuYahRgKPa_JNyTuhYA`,
  variants: {
    Icons: {
      id: '1',
    },
  },
}

export const LifeInsuranceSimplifiedOffers: ExperimentType = {
  activationEvent: 'optimize.activate.CQcMnGIZROWNrpvjMEQAoQ',
  id: 'CQcMnGIZROWNrpvjMEQAoQ',
  objectiveEvent: 'optimize.objective.CQcMnGIZROWNrpvjMEQAoQ',
  variants: {
    UpdatedRatesDisplay: {
      id: '1',
    },
  },
}

// Export the Experiment, Original, and Variant components to provide an easier import experimence
// e.g. import { Experiment, Original, Variant } from 'embed/experiments'
export { Experiment, Original, Variant, withExperiment }
